import { Link } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
const Header=() => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
  document.body.style.overflow = isMobileMenuOpen ? "hidden" : "auto";
}, [isMobileMenuOpen]);


      useEffect(() => {
       const items = document.querySelectorAll(".faq-item h3, .faq-item .faq-toggle");
       items.forEach((faqItem) => {
         faqItem.addEventListener("click", () => {
           faqItem.parentNode.classList.toggle("faq-active");
         });
       });
   
       return () => {
         items.forEach((faqItem) => {
           faqItem.replaceWith(faqItem.cloneNode(true));
         });
       };
     }, []);
   
      const techs = [
       { name: "Angular", icon: "bi-code-slash", color: "orange" },
       { name: "React", icon: "bi-lightning-charge", color: "blue" },
       { name: "AWS", icon: "bi-cloud", color: "green" },
       { name: "Docker", icon: "bi-box-seam", color: "red" },
       { name: "Azure", icon: "bi-cloud-arrow-up", color: "purple" },
       { name: "Vue", icon: "bi-diagram-3", color: "teal" },
       { name: "Python", icon: "bi-cpu", color: "yellow" },
       { name: "JavaScript", icon: "bi-braces", color: "pink" },
       { name: "Semantic", icon: "bi-layout-text-window", color: "cyan" },
       { name: "Go Lang", icon: "bi-gear", color: "orange" },
       { name: ".NET", icon: "bi-windows", color: "blue" },
       { name: "PHP", icon: "bi-file-code", color: "green" },
       { name: "NodeJs", icon: "bi-node-plus", color: "red" },
       { name: "CSS 3", icon: "bi-palette", color: "purple" },
       { name: "Bootstrap", icon: "bi-layers", color: "teal" },
       { name: "Big Data", icon: "bi-bar-chart", color: "yellow" },
       { name: "Salesforce", icon: "bi-lightbulb", color: "pink" },
       { name: "DevOps", icon: "bi-gear-wide-connected", color: "cyan" },
       { name: "Workday", icon: "bi-briefcase", color: "orange" },
     ];
     const activateTab = (tabId) => {
     // Remove active/show from all tabs
     const allTabs = document.querySelectorAll(".tab-pane");
     allTabs.forEach(tab => {
       tab.classList.remove("active", "show");
     });
   
     // Remove active class from all nav links
     const allNavLinks = document.querySelectorAll(".nav-link");
     allNavLinks.forEach(link => link.classList.remove("active", "show"));
   
     // Add active/show to clicked tab
     const targetTab = document.getElementById(tabId);
     if (targetTab) targetTab.classList.add("active", "show");
   
     // Add active class to corresponding nav link
     const navLink = document.querySelector(`a[data-bs-target="#${tabId}"]`);
     if (navLink) navLink.classList.add("active", "show");
   
     // Scroll to services section smoothly
     document.getElementById("services")?.scrollIntoView({ behavior: "smooth" });
      };
   
      const [isReading, setIsReading] = useState(false);
        const [assistantActive, setAssistantActive] = useState(false);
        const [hasGreeted, setHasGreeted] = useState(false);
        const [voicesReady, setVoicesReady] = useState(false);
      
        const speechRecRef = useRef(null);
        const highlightTimerRef = useRef(null);
        const fallbackTimerRef = useRef(null);
        const utteranceRef = useRef(null);
        const selectedVoiceRef = useRef(null);
      
        // Preselected female voice name preferences (order matters)
        const femaleVoicePriority = [
          // common voice names on Chrome/Windows/Mac OS variants
          "Google UK English Female",
          "Google US English",
          "Samantha", // macOS
          "Alex", // macOS (male but good TTS); fallback
          "Microsoft Zira Desktop",
          "Microsoft Hazel Desktop",
          "Microsoft Heera Desktop",
          "Karen",
        ];
      
        useEffect(() => {
          // Load voices and choose a preferred voice when available
          const loadVoices = () => {
            const voices = window.speechSynthesis.getVoices() || [];
            if (voices.length > 0) {
              selectedVoiceRef.current = choosePreferredVoice(voices);
              setVoicesReady(true);
            }
          };
      
          loadVoices();
          // Some browsers load voices asynchronously
          window.speechSynthesis.onvoiceschanged = () => {
            loadVoices();
          };
      
          // cleanup
          return () => {
            window.speechSynthesis.onvoiceschanged = null;
            stopReadingImmediate();
            if (speechRecRef.current) {
              try {
                speechRecRef.current.stop();
              } catch (e) {}
            }
          };
          // eslint-disable-next-line react-hooks/exhaustive-deps
        }, []);
      
        const choosePreferredVoice = (voices) => {
          // try by priority names
          for (const name of femaleVoicePriority) {
            const found = voices.find((v) => v.name && v.name.includes(name));
            if (found) return found;
          }
      
          // otherwise prefer voices where lang includes 'en' and name includes female-like keywords
          const femaleLike = voices.find(
            (v) =>
              v.lang && v.lang.toLowerCase().startsWith("en") &&
              (v.name && /female|woman|zira|samantha|karen|hazel|alloy|google/i.test(v.name))
          );
          if (femaleLike) return femaleLike;
      
          // final fallback: any 'en' voice
          const en = voices.find((v) => v.lang && v.lang.toLowerCase().startsWith("en"));
          if (en) return en;
      
          // else the first available voice
          return voices[0] || null;
        };
      
        /* -------------------- Text reading + highlighting -------------------- */
      
        // Read a element's text content with word-by-word highlight.
        // elementSelector: CSS selector or element (if passed as element, we use directly)
        const readElementText = (elementOrSelector) => {
          const element =
            typeof elementOrSelector === "string"
              ? document.querySelector(elementOrSelector)
              : elementOrSelector;
          if (!element) {
            console.warn("Element to read not found:", elementOrSelector);
            return;
          }
      
          stopReadingImmediate(); // ensure previous speech stopped
      
          const plainText = getPlainText(element);
          if (!plainText.trim()) return;
      
          const u = new window.SpeechSynthesisUtterance(plainText);
          u.rate = 0.9; // slower reading
          u.pitch = 1.0;
          u.lang = "en-US";
          if (selectedVoiceRef.current) u.voice = selectedVoiceRef.current;
      
          utteranceRef.current = u;
          setIsReading(true);
      
          // bind events
          let boundarySupported = false;
          u.onboundary = (ev) => {
            boundarySupported = true;
            // event.charIndex gives index into full text
            if (ev.charIndex !== undefined) {
              applyHighlightByCharIndex(element, plainText, ev.charIndex);
            }
          };
      
          u.onend = () => {
            clearAllHighlighting(element, plainText);
            setIsReading(false);
            clearTimers();
          };
      
          // fallback if onboundary isn't supported in this browser: estimate word timings
          // We'll compute rough durations and step through words
          // Start speaking, then if onboundary didn't fire after a short delay, start fallback timer.
          window.speechSynthesis.speak(u);
      
          // start fallback check after 250ms
          fallbackTimerRef.current = setTimeout(() => {
            if (!boundarySupported) {
              // start estimated highlighting
              startFallbackHighlight(element, plainText, u.rate);
            }
          }, 250);
        };
      
        // Get plain text of element (no tags). Keep small whitespace formatting.
        const getPlainText = (el) => {
          // prefer textContent but keep spacing
          return el.textContent || el.innerText || "";
        };
      
        const applyHighlightByCharIndex = (element, fullText, charIndex) => {
          // We find the current word from charIndex and wrap that word in span
          // Preserve original whitespace by reconstructing innerHTML from slices.
          const before = fullText.slice(0, charIndex);
          const after = fullText.slice(charIndex);
          // extract current word
          const wordsBefore = before.split(/\s+/);
          let currentWord = wordsBefore[wordsBefore.length - 1] || "";
          // fallback if empty
          if (!currentWord) {
            // try to skip any non-word
            const trimmed = fullText.slice(charIndex).trim();
            currentWord = trimmed.split(/\s+/)[0] || "";
          }
      
          const start = Math.max(0, before.lastIndexOf(currentWord));
          const end = start + currentWord.length;
      
          // escape HTML (we'll set innerHTML to composed string)
          const esc = (s) =>
            s
              .replace(/&/g, "&amp;")
              .replace(/</g, "&lt;")
              .replace(/>/g, "&gt;")
              .replace(/"/g, "&quot;");
      
          const part1 = esc(fullText.slice(0, start));
          const partHighlight = esc(fullText.slice(start, end));
          const part2 = esc(fullText.slice(end));
      
          element.innerHTML =
            part1 +
            `<span class="tts-highlight" style="background:lightblue;border-radius:3px;">` +
            partHighlight +
            `</span>` +
            part2;
        };
      
        const clearAllHighlighting = (element, fullText) => {
          // put plain text back
          element.innerText = fullText;
          // clear timers
          clearTimers();
        };
      
        const clearTimers = () => {
          if (highlightTimerRef.current) {
            clearInterval(highlightTimerRef.current);
            highlightTimerRef.current = null;
          }
          if (fallbackTimerRef.current) {
            clearTimeout(fallbackTimerRef.current);
            fallbackTimerRef.current = null;
          }
        };
      
        const startFallbackHighlight = (element, fullText, rate = 1.0) => {
          // Estimate reading duration: average characters spoken per second at rate=1 ~ 13
          // (This is heuristic; adjust if needed)
          const avgCharsPerSec = 13 * rate;
          const estimatedTotalSec = Math.max(1, fullText.length / avgCharsPerSec);
          const words = fullText.split(/\s+/).filter(Boolean);
          if (words.length === 0) return;
      
          // compute duration proportionally per word by its char length
          const totalChars = words.reduce((s, w) => s + w.length, 0);
          const wordDurations = words.map((w) => (w.length / totalChars) * estimatedTotalSec);
      
          // iterate words
          let idx = 0;
          const paintWord = () => {
            if (!words[idx]) {
              // finish
              element.innerText = fullText;
              setIsReading(false);
              clearTimers();
              return;
            }
            // Rebuild string highlighting words[idx]
            const prefix = words.slice(0, idx).join(" ");
            const current = words[idx];
            const suffix = words.slice(idx + 1).join(" ");
      
            // careful: reconstruct with same spacing - using split/join loses multiple spaces/newlines.
            // For fallback we will approximate using single spaces.
            element.innerHTML =
              (prefix ? prefix + " " : "") +
              `<span class="tts-highlight" style="background:lightblue;border-radius:3px;">${current}</span>` +
              (suffix ? " " + suffix : "");
      
            const durMs = Math.max(80, Math.round(wordDurations[idx] * 1000));
            idx++;
            highlightTimerRef.current = setTimeout(paintWord, durMs);
          };
      
          paintWord();
        };
      
        const stopReadingImmediate = () => {
          // stop speech and clear highlight/timers
          window.speechSynthesis.cancel();
          utteranceRef.current = null;
          clearTimers();
          // restore any element innerText to original for any open sections we may have changed
          // (We will try to find any highlighted elements and remove highlight)
          const highlighted = document.querySelectorAll(".tts-highlight");
          highlighted.forEach((span) => {
            const parent = span.parentNode;
            if (parent) {
              // replace parent HTML with its textContent (best-effort)
              const parentFull = parent.innerText || parent.textContent || "";
              parent.innerText = parentFull;
            }
          });
          setIsReading(false);
        };
      
   /* -------------------- Voice Assistant (Fast Navigation) -------------------- */
   
   const startAssistant = () => {
     if (assistantActive) {
       askForSectionAgain();
       return;
     }
     setAssistantActive(true);
   
     if (!hasGreeted) {
       speakText("Hello! How are you today?", () => {
         waitUserResponse(handleFirstResponse);
       });
       setHasGreeted(true);
     } else {
       askForSectionAgain();
     }
   };
   
   const askForSectionAgain = () => {
     speakText("Now which page do you want to open?", () => {
       waitUserResponse(handleSectionResponse);
     });
   };
   
   const speakText = (text, onEnd) => {
     window.speechSynthesis.cancel();
     const u = new window.SpeechSynthesisUtterance(text);
     u.rate = 1.2; // faster speech
     u.pitch = 1.1;
     u.lang = "en-US";
     if (selectedVoiceRef.current) u.voice = selectedVoiceRef.current;
     u.onend = onEnd;
     window.speechSynthesis.speak(u);
   };
   
   const waitUserResponse = (callback) => {
     const Recognition = window.SpeechRecognition || window.webkitSpeechRecognition;
     if (!Recognition) {
       const fallback = window.prompt("Please type your response (fallback):");
       if (fallback) callback(fallback.toLowerCase());
       return;
     }
   
     const recognition = new Recognition();
     recognition.lang = "en-US";
     recognition.continuous = false;
     recognition.interimResults = false;
   
     recognition.onresult = (event) => {
       const transcript = event.results[0][0].transcript.toLowerCase();
       callback(transcript);
     };
   
     recognition.onerror = () => {
       const fallback = window.prompt("Type your response:");
       if (fallback) callback(fallback.toLowerCase());
     };
   
     recognition.start();
   };
   
   const handleFirstResponse = (transcript) => {
     const positive = ["fine", "good", "great", "doing well"];
     const isPositive = positive.some((p) => transcript.includes(p));
     if (isPositive) {
       speakText("Glad to hear that! Which page would you like to open?", () => {
         waitUserResponse(handleSectionResponse);
       });
     } else {
       speakText("Alright. Which page would you like to open?", () => {
         waitUserResponse(handleSectionResponse);
       });
     }
   };
   
   const pagesList = ["home", "about", "services", "features", "blog", "contact"];
   
   const handleSectionResponse = (transcript) => {
     const found = pagesList.find((p) => transcript.includes(p));
     if (found) {
       navigateToPage(found);
     } else {
       speakText("I couldn't find that page. Please say Home, About, Services, Features, Blog, or Contact.", () => {
         waitUserResponse(handleSectionResponse);
       });
     }
   };
   
   const navigateToPage = (page) => {
     // If you’re using React Router
     const pageMap = {
       home: "/",
       about: "/about",
       services: "/services",
       features: "/features",
       blog: "/blog",
       contact: "/contact"
     };
   
     const path = pageMap[page] || "/";
     window.location.href = path; // fast navigation
     speakText(`Opening ${page} page.`);
   };
   
   /* Optional stop function */
   const stopAssistantAndReading = () => {
     window.speechSynthesis.cancel();
     setAssistantActive(false);
   };
   
    return (
       <div>
        <header id="header" className="header d-flex align-items-center fixed-top">
    <div className="header-container container-fluid container-xl position-relative d-flex align-items-center justify-content-between">
      {/* <a href="index-2.html" className="logo d-flex align-items-center me-auto me-xl-0"> */}
      
        <div className="logo d-flex align-items-center me-auto me-xl-0">
          <Link to="/">
            <img src="assets/header_logo2.svg" alt="" />
          </Link>
          
        </div>
        
     
      <nav
  id="navmenu"
  className={`navmenu ${isMobileMenuOpen ? "mobile-nav-active" : ""}`}
>
  <ul>
    <li>
      <Link to="/" onClick={() => setIsMobileMenuOpen(false)}>
        Home
      </Link>
    </li>

    <li>
      <Link to="/about" onClick={() => setIsMobileMenuOpen(false)}>
        About Us
      </Link>
    </li>

    <li>
      <Link to="/services" onClick={() => setIsMobileMenuOpen(false)}>
        Services
      </Link>
    </li>

    <li>
      <Link to="/features" onClick={() => setIsMobileMenuOpen(false)}>
        Features
      </Link>
    </li>

    <li>
      <Link to="/blog" onClick={() => setIsMobileMenuOpen(false)}>
        Blogs
      </Link>
    </li>

    <li>
      <Link to="/contact" onClick={() => setIsMobileMenuOpen(false)}>
        Contact
      </Link>
    </li>
  </ul>
</nav>

<i
  className={`mobile-nav-toggle d-xl-none bi ${
    isMobileMenuOpen ? "bi-x" : "bi-list"
  }`}
  onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
/>
<style dangerouslySetInnerHTML={{__html: "\n  @media (max-width: 1199px) {\n  .navmenu {\n    display: none;\n  }\n\n  .navmenu.mobile-nav-active {\n    display: block;\n    position: absolute;\n    top: 70px;\n    left: 0;\n    right: 0;\n    background: #fff;\n    z-index: 999;\n    padding: 20px;\n  }\n}\n\n" }} />


<style
  dangerouslySetInnerHTML={{
    __html: `
@media (max-width: 1199px) {

  .navmenu {
    display: none;
  }

  .navmenu.mobile-nav-active {
    display: block;
    position: absolute;
    top: 70px;
    left: 0;
    right: 0;
    background: #fff;
    z-index: 9999;
    padding: 20px;
  }

  /* 🔥 THIS IS THE MISSING PART */
  .navmenu.mobile-nav-active ul {
    display: block !important;
    opacity: 1 !important;
    visibility: visible !important;
    position: relative;
  }

  .navmenu.mobile-nav-active ul li {
    display: block;
    padding: 12px 0;
  }

  .navmenu.mobile-nav-active ul li a {
    display: block;
    font-size: 16px;
    color: #000;
  }
}
    `,
  }}
/>


      <Link className="btn-getstarted" to="/contact">Get Started</Link>
       {/* Floating Assistant Button
        {!assistantActive ? (
          <button
            title="Open Voice Assistant"
            className="assistant-button assistant-start"
            onClick={startAssistant}
          >
            🔊
          </button>
        ) : (
          <div style={{ position: "fixed", right: 30, bottom: 30, zIndex: 9999, display: "flex", gap: 8 }}>
            <button
              title="Ask Section"
              className="assistant-button assistant-start"
              onClick={() => {
                if (!hasGreeted) {
                  startAssistant();
                } else {
                  askForSectionAgain();
                }
              }}
            >
              🗣️
            </button>
            <button
              title="Stop assistant & reading"
              className="assistant-button assistant-stop"
              onClick={stopAssistantAndReading}
            >
              ⛔
            </button>
          </div>
        )} */}
    </div>
  </header>
       </div>
    );
};

export default Header;